<script setup lang="ts">
defineProps<{ label: string; icon: 'income' | 'expense' | 'net' | 'savings' }>()

const TILE_CLASSES = {
  income:
    'bg-[color:color-mix(in_srgb,var(--color-income)_12%,transparent)] text-[color:var(--color-income)]',
  expense:
    'bg-[color:color-mix(in_srgb,var(--color-expense)_12%,transparent)] text-[color:var(--color-expense)]',
  net: 'bg-[color:color-mix(in_srgb,var(--color-transfer)_12%,transparent)] text-[color:var(--color-transfer)]',
  savings:
    'bg-[color:color-mix(in_srgb,var(--color-positive)_12%,transparent)] text-[color:var(--color-positive)]',
} as const
</script>

<template>
  <article
    class="flex min-w-0 flex-col gap-[var(--space-inline)] rounded-[var(--radius-surface)] border border-[color:var(--color-border)] bg-[color:var(--color-surface)] p-[var(--space-group)]"
  >
    <header class="flex items-center gap-3">
      <span
        aria-hidden="true"
        :class="[
          'flex h-9 w-9 shrink-0 items-center justify-center rounded-[var(--radius-control)]',
          TILE_CLASSES[icon],
        ]"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 16 16"
          fill="none"
          stroke="currentColor"
          stroke-width="1.6"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path v-if="icon === 'income'" d="M8 3v10M4.5 9.5 8 13l3.5-3.5M3 4.5h10" />
          <path v-else-if="icon === 'expense'" d="M8 13V3M4.5 6.5 8 3l3.5 3.5M3 11.5h10" />
          <path v-else-if="icon === 'net'" d="M3 12.5 6.5 9l2.5 2.5L13 6.5M10 6.5h3v3" />
          <path v-else d="M3 13a5 5 0 0 1 10 0M8 8V4" />
        </svg>
      </span>
      <h2 class="text-[length:var(--text-step-2)] font-medium text-[color:var(--color-text-muted)]">
        {{ label }}
      </h2>
    </header>
    <div class="flex flex-col gap-[var(--space-tight)]">
      <slot />
    </div>
    <div class="min-h-[1.5rem]">
      <slot name="change" />
    </div>
  </article>
</template>
